import { Guid, SerializableObject } from '../../common-react/core';

import { LocationType } from '../other/location-type.enum';

import { Address } from './address.do';

/**
 * Post Boxes, Post Offices and other Posturinn locations.
 */
export class Location extends SerializableObject {
  public id: Guid;
  public name: string;
  public locationType: LocationType;
  public latitude: number;
  public longitude: number;
  public imageURL?: string;
  public address: Address;
  public statusMessage: string;

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    const returnValue: unknown = super.coercePropertyType(propertyName, propertyValue);

    switch (propertyName) {
      case 'address':
        if (!propertyValue) {
          // TODO: TP-8498 Throw an error when data is missing.
          // throw new Error(`Missing value for Location.${propertyName}`);
          return this.getUnknownLocation();
        }
        return new Address(propertyValue);

      default:
        return returnValue;
    }
  }

  private getUnknownLocation(): Location {
    return new Location({
      name: 'Unknown Location',
      address: {
        country: 'Unknown',
      },
    });
  }
}
